import { render } from "./base-header.vue?vue&type=template&id=0d6bc5c2&scoped=true&ts=true"
import script from "./base-header.vue?vue&type=script&lang=ts"
export * from "./base-header.vue?vue&type=script&lang=ts"

import "./base-header.vue?vue&type=style&index=0&id=0d6bc5c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6bc5c2"]])

export default __exports__